import Title from "./components/Title/Title";
import Paragraph from "./components/Paragraph/Paragraph";
import Button from "./components/Button/Button";
import OptionsItem from "./components/OptionsItem/OptionsItem";
import React, { useEffect, useState } from "react";
import imageStartScreen from "./assets/images/00.jpg";
import imageResultOne from "./assets/images/9-1.jpg";
import imageResultTwo from "./assets/images/9-2.jpg";
import imageResultThree from "./assets/images/9-3.jpg";
import styles from "./App.module.scss";
import questions from "./state/questions";
import classNames from "classnames";
import Result from "./components/Result/Result";

function App() {
  const [currentQuestion, setCurrentQuestion] = useState(0); // считаем номер вопроса
  const [stateFlow, setStateFlow] = useState("Start"); // состояние флоу: стартовый экран / вопросы / результат
  const [option, setOption] = useState(false); // выбран ли ответ
  const [resultState, setResultState] = useState(""); // выводить ли результат
  const [resultCount, setResultCount] = useState(0); // счетчик правильных вопросов
  const phone = document.getElementById("phone"); // находим область телефона на десктопе

  // console.log(resultCount); // тестирование логики

  // прокрутка вниз при нажатии на ответ
  const optionActiveHandler = (option) => {
    setOption(option);

    setTimeout(() => {
      window.scrollTo({ top: 1000, behavior: "smooth" });
      phone.scrollTo({ top: 1000, behavior: "smooth" });
    }, "50");
  };

  const resultCountLogic = (result) => {
    setResultCount(resultCount + result);
  };

  // поднимаемся наверх после перехода на страницу
  const scrollReset = (event) => {
    window.scrollTo(0, 0);
    phone.scrollTo(0, 0);
  };

  // Скролл наверх при нажатии старт квиз
  const startFlow = () => {
    setStateFlow("Flow");
    window.scrollTo(0, 0);
  };

  // логика флоу
  const handlerNext = () => {
    if (currentQuestion === 5) {
      setStateFlow("End");

      setResultState(() => {
        if (resultCount <= 2) {
          return (
            <Result
              score={resultCount + "/6"}
              title="Ke depannya masih ada begitu banyak hal baru! 🔎"
              text={
                <>
                  Kami harap, kuis ini membantu kamu untuk mengetahui lebih
                  banyak tentang Indonesia tercinta. Hadiah kamu—kode promo
                  senilai Rp200.000: <b>HUTRI81</b>
                </>
              }
              descOne={
                "Perjalanan dan pengiriman jadi makin murah. Aktifkan sekarang dan bagikan dengan teman."
              }
              descTwo={
                "🚖 Kode promo untuk para pengguna yang belum melakukan order di aplikasi Maxim selama 7 hari atau lebih."
              }
              imageSrc={imageResultThree}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }

        if (resultCount >= 3 && resultCount <= 4) {
          return (
            <Result
              score={resultCount + "/6"}
              title="Lumayan! 👍"
              text={
                <>
                  Kamu ingat fakta-fakta penting dan ini awal yang bagus. Hadiah
                  kamu—kode promo senilai Rp200.000: <b>HUTRI81</b>
                </>
              }
              descOne={
                "Perjalanan dan pengiriman jadi makin murah. Aktifkan sekarang dan bagikan dengan teman."
              }
              descTwo={
                "🚖 Kode promo untuk para pengguna yang belum melakukan order di aplikasi Maxim selama 7 hari atau lebih."
              }
              imageSrc={imageResultTwo}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }

        if (resultCount >= 5 && resultCount <= 6) {
          return (
            <Result
              score={resultCount + "/6"}
              title="Pakar sejati! 💥"
              text={
                <>
                  Kamu mengetahui dengan sangat baik sejarah Indonesia: kamu
                  ingat para pahlawan, tanggal, dan simbol negara. Hadiah
                  kamu—kode promo senilai Rp200.000: <b>HUTRI81</b>
                </>
              }
              descOne={
                "Perjalanan dan pengiriman jadi makin murah. Aktifkan sekarang dan bagikan dengan teman."
              }
              descTwo={
                "🚖 Kode promo untuk para pengguna yang belum melakukan order di aplikasi Maxim selama 7 hari atau lebih."
              }
              imageSrc={imageResultOne}
              posterContainer={styles.posterContainer}
              optionsContainer={styles.optionsContainer}
              handlerBack={handlerBack}
            />
          );
        }
      });

      // сбрасываем  скролл для результата
      scrollReset();
    } else {
      setOption(false);
      setCurrentQuestion(currentQuestion + 1);

      // прокрутка вверх после нажатия на ответ
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        phone.scrollTo({ top: 0, behavior: "smooth" });
      }, "50");
    }
  };

  // возвращение в начало
  const handlerBack = () => {
    setOption(false);
    setStateFlow("Start");
    setCurrentQuestion(0);
    setResultCount(0);
  };

  // считаем цифры прокрутки и верешаем options::after
  const [offset, setOffset] = useState(false);

  useEffect(() => {
    const handleScroll = (event) => {
      if (window.scrollY > 50) {
        setOffset(true);
      } else {
        setOffset(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.wrapperContainer}>
      <div className={styles.wrapper}>
        <div className={styles.phone} id="phone">
          {stateFlow === "Start" ? (
            <>
              <div className={styles.posterContainer}>
                <img src={imageStartScreen} className={styles.image} alt="" />
              </div>
              <div
                className={classNames({
                  [styles.optionsContainer]: true,
                  [styles.onScrollOption]: offset,
                })}
              >
                <div className={styles.bgWhite}>
                  <div className={styles.contentWrapper}>
                    <Title value="Maxim 8 Tahun di Indonesia 🥳" />
                    <Paragraph value="Dalam rangka memperingati Hari Ulang Tahun dan Hari Kemerdekaan RI, kami mengajak Anda sekalian untuk mengenang kembali perjalanan panjang negeri ini menuju kemerdekaan. Ikuti kuis bertemakan perayaan ini hingga selesai dan bawa pulang hadiahnya: Rp200.000 untuk perjalanan bersama Maxim." />
                  </div>
                  <Button
                    value="Maju!"
                    onClick={() => startFlow()}
                    id="start"
                  />
                </div>
              </div>
            </>
          ) : stateFlow === "Flow" ? (
            <>
              <div className={styles.posterContainer}>
                <img
                  src={questions[currentQuestion].image}
                  className={styles.image}
                  alt={questions[currentQuestion].image}
                />
              </div>
              <div
                className={classNames({
                  [styles.optionsContainer]: true,
                  [styles.onScrollOption]: offset,
                })}
              >
                <div className={styles.bgWhite}>
                  <div className={styles.header}>
                    <div className={styles.topBarContainer}>
                      <div>
                        Pertanyaan {currentQuestion + 1} of {questions.length}
                      </div>
                    </div>
                    <div>
                      <div className={styles.headerDesc}>
                        <Title
                          value={questions[currentQuestion].questionDesc}
                        />
                      </div>
                    </div>
                  </div>

                  <div className={styles.optionsWrapper}>
                    {questions[currentQuestion].answerOptions.map((item) => (
                      <OptionsItem
                        key={item.answerText}
                        title={item.answerText}
                        resultText={item.answerResult}
                        onClick={optionActiveHandler}
                        disabled={option}
                        result={item.result}
                        resultCountLogic={resultCountLogic}
                      />
                    ))}
                  </div>

                  <Button
                    value="Berikutnya"
                    onClick={() => handlerNext()}
                    disabled={!option}
                    id={"btn" + (currentQuestion + 1)}
                  />
                </div>
              </div>
            </>
          ) : (
            <>{resultState}</>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
